export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  FORIA = 'ROLE_FORIA',
  SUPPLIER = 'ROLE_SUPPLIER',
  COMPANY = 'ROLE_COMPANY',
  LAB = 'ROLE_LAB',
  INSPECTOR = 'ROLE_INSPECTOR'
}
